import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { bookingRecordQuery } from "@/app/Bookings/GraphQL/bookingRecordQuery";
import {
  ManualAssignButton,
  MatchingRelocationsTable,
  SimilarRelocationsTable,
} from "@/app/Bookings/Components/FindRelocation/MatchingRelocationsTable";
import { useFindRelocationTables } from "@/app/Bookings/Components/FindRelocation/useFindRelocationTables";
import { formatDate } from "@/lib/Formatters/formatDate";

type BookingFindRelocationDialogProps = {
  bookingId: string;
};
export function BookingFindRelocationDialog({
  bookingId,
}: BookingFindRelocationDialogProps) {
  const { close } = useDialogState();
  const { data } = useSuspenseGqlQuery(bookingRecordQuery, {
    id: bookingId,
  });

  const booking = data.booking;

  useFindRelocationTables(booking);

  return (
    <BaseDialog
      title={
        <div className="flex items-start justify-between gap-4">
          <span>Find similar relocations</span>
          <ManualAssignButton booking={booking} />
        </div>
      }
      subtitle={
        <>
          {booking.reference}
          <span className="text-zinc-300 dark:text-zinc-600">{" · "}</span>
          {booking.departureOffice.city.name}
          {" → "}
          {booking.deliveryOffice.city.name}
          <span className="text-zinc-300 dark:text-zinc-600">{" · "}</span>
          {formatDate(booking.depart_at)}
          {" – "}
          {formatDate(booking.deliver_at)}
        </>
      }
      size="5xl"
    >
      <div className="space-y-8">
        <MatchingRelocationsTable
          booking={booking}
          onAssign={() => {
            close();
          }}
        />
        <SimilarRelocationsTable
          booking={booking}
          onAssign={() => {
            close();
          }}
        />
      </div>
    </BaseDialog>
  );
}
